module.exports = __webpack_public_path__ + "img/success.3ed54ebb.png";